import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-324edcb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "right" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"18px"} }, null, -1))
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "items" }
const _hoisted_10 = { class: "img" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["alt"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "icon" }
const _hoisted_15 = {
  key: 0,
  class: "empty",
  style: {"width":"100%","height":"300px","display":"flex","align-items":"center","justify-content":"center"}
}

import { Search } from '@element-plus/icons-vue'
import { computed, ref, watch } from 'vue';
import { usePinia } from '@/store';
import { storeToRefs } from 'pinia'
import router from '@/router';
import { getDetail } from '@/api/contact'
import { ElMessage } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = usePinia()
const { shopList, showShop, detail, showShopBt, active } = storeToRefs(store) as any
showShopBt.value = true

//去往=详情
const toDetail = ele => {
  detail.value = ele
  router.push({
    name: 'similar-detail', query: {
      id: ele.id,
      category: ele.category,
      essentialDetailsKey: ele.essentialDetailsKey
    }
  })
}

const aHref = (v) => {
  return `/products/similar-detail.html?id=${v.id}&category=${v.category}&essentialDetailsKey=${v.essentialDetailsKey}`
}

//添加到购物车
const add = ele => {
  shopList.value.push(ele)
  showShop.value = true
}
//判断商品是否在购物车
const state = ele => {
  const active = shopList.value.find(v => v.id === ele.id)
  if (active) {
    return true
  } else {
    return false
  }
}

//去往商品大类页面
const toSimilarGoods = key => {
  router.push({
    name: 'similar-goods',
    query: { type: key }
  })
}

//轮询图片分割 
const splitImg = (imgs): any => {
  try {
    const list = imgs.split(',')
    return list[1]
  } catch (err) {
    console.log('分割图片出错了');
  }
}

//商品分类列表
const list: any = ref({})
//钢材，塑料切换
const activeObj = {
  'PLASTICS MATERIAL': 0,
  'STEELS MATERIAL': 1
}
const input = ref('')
const getList = async () => {
  const res = await getDetail({ group: activeObj[active.value], title: input.value }) as any
  if (res) {
    list.value = res.data.filter(v => v.count)
  } else {
    ElMessage.error(res.message)
  }
}
getList()
watch(active, (newVal, oldVal) => {
  getList()
})




return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_CirclePlus = _resolveComponent("CirclePlus")!
  const _component_CircleCheck = _resolveComponent("CircleCheck")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: input.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
          placeholder: "What are you looking for…",
          class: "inputDeep",
          style: {"border":"none"}
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, { onClick: getList }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { color: "#fff" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Search))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _hoisted_4
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "father-item",
          key: item.name
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString(item.name) + "（" + _toDisplayString(item.count) + "）", 1),
            _createElementVNode("p", {
              class: "link",
              onClick: ($event: any) => (toSimilarGoods(item.name))
            }, " More ", 8, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.dataList, (ele, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: ele.id,
                style: _normalizeStyle({ marginRight: i !== 3 ? '20px' : '' })
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", {
                    href: aHref(ele)
                  }, [
                    _withDirectives(_createElementVNode("img", {
                      alt: ele.title
                    }, null, 8, _hoisted_12), [
                      [_directive_lazy, splitImg(ele.allImg)]
                    ])
                  ], 8, _hoisted_11)
                ]),
                _createElementVNode("div", {
                  class: "text",
                  onClick: ($event: any) => (toDetail(ele))
                }, _toDisplayString(ele.title), 9, _hoisted_13),
                _createElementVNode("div", _hoisted_14, [
                  (!state(ele))
                    ? (_openBlock(), _createBlock(_component_el_icon, {
                        key: 0,
                        size: 26,
                        color: "#ccc",
                        onClick: ($event: any) => (add(ele))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CirclePlus)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_el_icon, {
                        key: 1,
                        size: 26,
                        color: "#FF771C"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CircleCheck)
                        ]),
                        _: 1
                      }))
                ])
              ], 4))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    (!list.value || !list.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, "NO DATA...."))
      : _createCommentVNode("", true)
  ]))
}
}

})